import { emailjs } from '../config/emailjs';

export class EmailService {
    /**
     * Gửi email liên hệ đến admin
     * @param {Object} formData - Dữ liệu form liên hệ
     * @returns {Promise} - Promise trả về kết quả gửi email
     */
    static async sendContactEmail(formData) {
        try {
            const templateParams = {
                from_name: formData.name,
                from_email: formData.email,
                from_phone: formData.phone,
                service: formData.service,
                message: formData.message,
                to_name: 'NAVO Sổ Tiệm',
            };

            const result = await emailjs.send(
                'service_be0w86m',
                'template_nwnim9i', // template contact us
                templateParams,
            );

            return { success: true, result };
        } catch (error) {
            return { success: false, error };
        }
    }

    /**
     * Gửi email reply cho khách hàng
     * @param {Object} customerData - Thông tin khách hàng
     * @param {string} replyMessage - Nội dung reply
     * @returns {Promise} - Promise trả về kết quả gửi email
     */
    static async sendReplyEmail(customerData, replyMessage) {
        try {
            // Template variables phù hợp với template_travy1g trong EmailJS dashboard
            const templateParams = {
                from_name: customerData.name, // Tên khách hàng
                from_email: customerData.email, // Email khách hàng
                from_phone: customerData.phone, // Số điện thoại khách hàng
                service: customerData.service || 'Chưa chọn', // Dịch vụ quan tâm
                message: customerData.message, // Nội dung tin nhắn gốc
                reply_message: replyMessage, // Nội dung reply (nếu cần)
            };

            const result = await emailjs.send(
                'service_be0w86m',
                'template_travy1g', // template reply
                templateParams,
            );
            return { success: true, result };
        } catch (error) {
            return { success: false, error };
        }
    }

    /**
     * Xử lý form liên hệ hoàn chỉnh: gửi email admin và reply khách
     * @param {Object} formData - Dữ liệu form liên hệ
     * @returns {Promise} - Promise trả về kết quả xử lý
     */
    static async handleContactForm(formData) {
        try {
            // 1. Gửi email thông báo cho admin
            const contactResult = await this.sendContactEmail(formData);

            if (!contactResult.success) {
                throw new Error('Không thể gửi email thông báo');
            }

            // 2. Tạo nội dung reply tự động (đơn giản hóa vì template đã có sẵn nội dung)
            const replyMessage = `Chào ${formData.name}, cảm ơn bạn đã liên hệ với NAVO Sổ Tiệm. Chúng tôi sẽ phản hồi trong vòng 24h.`;

            // 3. Gửi email reply cho khách hàng
            const replyResult = await this.sendReplyEmail(formData, replyMessage);

            return {
                success: true,
                contactSent: contactResult.success,
                replySent: replyResult.success,
            };
        } catch (error) {
            return { success: false, error: error.message };
        }
    }
}

export default EmailService;
